import angular from 'angular';

module.exports = angular.module('common.services.autocomplete-to-address', [
])
.factory('autocompleteToAddress', function() {
  return function(autocomplete, address) {
    address = address || {};

    angular.forEach(autocomplete.address_components, function(component) {
      switch (component.types[0]) {
        case 'street_number':
          address.street1 = component.short_name;
          break;
        case 'route':
          address.street1 += ' ' + component.short_name;
          break;
        case 'locality':
          address.city = component.long_name;
          break;
        case 'administrative_area_level_1':
          address.state = component.short_name;
          break;
        case 'postal_code':
          address.postal_code = component.short_name;
          break;
        default:
      }
    });

    address.latitude = autocomplete.geometry.location.lat();
    address.longitude = autocomplete.geometry.location.lng();

    return address;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/autocomplete-to-address.js
 **/